import { gql } from '@apollo/client'

export const SEND_WORKSPACE_INVITATION = gql`
  mutation SendWorkspaceInvitation($email: LowercaseString!, $teamId: ID!, $workspaceId: UUID!) {
    sendWorkspaceInvitation(email: $email, teamId: $teamId, workspaceId: $workspaceId) {
      success
    }
  }
`
